import React, { Component, PropTypes } from 'react';
import ErrorField from '../ErrorField';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import './DateField.css';
import InputField from '../InputField';

import 'react-datepicker/dist/react-datepicker.css';


class DateField extends Component {
  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.handleFocus = this.handleFocus.bind(this);
    this.buildField = this.buildField.bind(this);
		this.getInputStyles = this.getInputStyles.bind(this);
  }

  handleChange(event) {
		const { handleChange, field } = this.props;
		let newDate = moment(event).format('MM/DD/YY');
		if (newDate === 'Invalid date') {
			newDate = moment().format('MM/DD/YY');
		}
    handleChange(newDate, field.name);
  }

  handleFocus() {
    this.props.handleFocus(this.props.field.name)
  }

  handleBlur() {
    this.props.handleBlur(this.props.field.name)
  }

	buildField(inputStyle) {
		const { field } = this.props;
		return (
			<div className="input-field-wrap">
				<input
					onFocus={this.handleFocus}
					onBlur={this.handleBlur}
					value={field.value ? moment(field.value).format('MM/DD/YY') : ''}
					className={inputStyle}/>
				<img className="dateField__icon" src="/images/calendar.png"></img>
			</div>
		)
	}

	getInputStyles() {
    const { field } = this.props;
		let inputStyle = 'dateField__wrap ';
		let placeholderStyle = 'input__placeholder ';
		if (field.touched === true) {
			placeholderStyle = placeholderStyle + 'input__touched ';
		}
		if (field.error && field.hasBlurred) {
			placeholderStyle = placeholderStyle + 'input__placeholder-error';
			inputStyle = inputStyle + 'input__border-error';
		} else if (!field.error && field.touched) {
			placeholderStyle = placeholderStyle + 'input__placeholder-success';
			inputStyle = inputStyle + 'input__border-success';
		}
		return { placeholderStyle, inputStyle };
	}

  render() {
		const { field } = this.props;
		let fieldStyle = this.getInputStyles();
    return (
			<div className="dateField">
				<DatePicker
					customInput={this.buildField(fieldStyle.inputStyle)}
					onChange={this.handleChange}
					selected={moment(field.value)}
					onChange={this.handleChange}>
				</DatePicker>
				<p className={fieldStyle.placeholderStyle}>
					{field.placeholder}
				</p>
				<ErrorField hasBlurred={field.hasBlurred} error={field.error}/>
			</div>
    );
  }
}

DateField.propTypes = {
  field: PropTypes.shape({
      value: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      error: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.object
      ]),
      placeholder: PropTypes.string.isRequired,
      hasBlurred: PropTypes.bool.isRequired,
      inputType: PropTypes.string.isRequired,
      breed: PropTypes.string.isRequired
    }),
  handleChange: PropTypes.func.isRequired,
  handleBlur: PropTypes.func.isRequired,
  handleFocus: PropTypes.func.isRequired
};

export default DateField;



/** WEBPACK FOOTER **
 ** ./src/components/DateField/index.js
 **/